/**
 * 模板市场-Taber容器
 * @author VenDream
 * @since 17/11/28
 */

import { connect } from 'react-redux';
import StoreTabs from 'components/store-tabs';
import { isJointLogin, isShowOpenZone } from 'utils/user';
import * as storeTabs from 'actions/store-tabs';

const { setActiveTab } = storeTabs;
const mapStateToProps = state => {
  const { userInfo, storeTabs } = state;
  const { templateCategoryCustomsFlag, templateCategoryCustoms } =
    userInfo.platformConfigInfo || {};

  return {
    ...storeTabs,
    isJointLogin: isJointLogin(state.userInfo),
    isShowOpenZone: isShowOpenZone(userInfo),
    templateCategoryCustomsFlag,
    templateCategoryCustoms,
  };
};

const mapDispatchToProps = dispatch => ({
  setActiveTab: (index, url) => {
    dispatch(setActiveTab(index));

    // 有url则推到history中
    // url && window.history.pushState({}, null, url);
    return url;
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StoreTabs);
